module.exports = __webpack_public_path__ + "public/images/Outschool_Logo_Color.cf40ca7955a51375a13a51387c38f21c.png";